<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 512 512">
    <path d="M123.6,391.3c12.9-9.4,29.6-11.8,44.6-6.4c26.5,9.6,56.2,15.1,87.8,15.1c124.7,0,208-80.5,208-160S380.7,80,256,80
	S48,160.5,48,240c0,32,12.4,62.8,35.7,89.2c8.6,9.7,12.8,22.5,11.8,35.5c-1.4,18.1-5.7,34.7-11.3,49.4c17-7.9,31.1-16.7,39.4-22.7
	V391.3z M21.2,431.9c1.8-2.7,3.5-5.4,5.1-8.1c10-16.6,19.5-38.4,21.4-62.9C17.7,326.8,0,285.1,0,240C0,125.1,114.6,32,256,32
	s256,93.1,256,208S397.4,448,256,448c-37.1,0-72.3-6.4-104.1-17.9c-11.9,8.7-31.3,20.6-54.3,30.6c-15.1,6.6-32.3,12.6-50.1,16.1
	c-0.8,0.2-1.6,0.3-2.4,0.5c-4.4,0.8-8.7,1.5-13.2,1.9c-0.2,0-0.5,0.1-0.7,0.1c-5.1,0.5-10.2,0.8-15.3,0.8c-6.5,0-12.3-3.9-14.8-9.9
	S0,457.4,4.5,452.8c4.1-4.2,7.8-8.7,11.3-13.5c1.7-2.3,3.3-4.6,4.8-6.9c0.1-0.2,0.2-0.3,0.3-0.5L21.2,431.9z"/>
    <g>
      <path d="M107.5,262.3c6.8,3.3,17.7,7.1,29.4,7.1c9.5,0,14.4-3,14.4-8.2c0-4.4-4.7-7.3-17.1-10.8c-17.4-4.8-31.8-13.8-31.8-31.5
		c0-18.5,16.7-32.1,43.2-32.1c13.9,0,23.3,2.4,31.2,5.8l-6.5,22.4c-4.8-2-13.5-5.3-25.2-5.3c-8.5,0-13.3,2.7-13.3,7.1
		c0,5.5,6.5,7.3,19.8,11.5c19.8,6.4,29.2,15.9,29.2,31.4c0,17.1-13.5,32.9-46.1,32.9c-13.5,0-26.7-3.6-33.2-7L107.5,262.3z"/>
      <path d="M291.1,252.8c-0.3-12.7-0.5-26.8-0.5-44.5h-0.5c-3.6,14.5-8.5,30.6-12.4,43.5l-11.1,37h-22.9l-9.1-36.8
		c-3-12.6-6.4-28.5-9.1-43.6h-0.3c-0.6,15.6-1.1,31.8-1.5,44.5l-1.5,38h-27l5.8-102.1h40.9l6.8,25.8c2.9,10.9,6.1,25,8.3,37.9h0.6
		c3.3-12.9,7.1-28,10.3-38.2l8-25.5H316l4.7,102.1h-28.5L291.1,252.8z"/>
      <path d="M341.7,262.3c6.8,3.3,17.7,7.1,29.4,7.1c9.5,0,14.4-3,14.4-8.2c0-4.4-4.7-7.3-17.1-10.8c-17.4-4.8-31.8-13.8-31.8-31.5
		c0-18.5,16.7-32.1,43.2-32.1c13.9,0,23.3,2.4,31.2,5.8l-6.5,22.4c-4.8-2-13.5-5.3-25.2-5.3c-8.5,0-13.3,2.7-13.3,7.1
		c0,5.5,6.5,7.3,19.8,11.5c19.8,6.4,29.2,15.9,29.2,31.4c0,17.1-13.5,32.9-46.1,32.9c-13.5,0-26.7-3.6-33.2-7L341.7,262.3z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SMS',
  props: {
    color: {
      type: String,
      default: '#FFFFFF'
    }
  }
}
</script>